import React from "react";

interface CustomeTextAreaProps {
  label?: string;
  rows?: number;
  className?: string;
  placeholder: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  onBlur?: React.FocusEventHandler<HTMLTextAreaElement>;
  error: boolean;
  helperText?: string;
  name: string;
}

const CustomeTextArea: React.FC<CustomeTextAreaProps> = ({
  label,
  rows,
  className,
  placeholder,
  value,
  onChange,
  onBlur,
  error,
  helperText,name
}) => {
  return (
    <div className="flex flex-col gap-1">
      {label && (
        <label htmlFor={label} className="text-sm font-medium text-grayColor pl-1 capitalize">
          {label}
        </label>
      )}
      <textarea
        id={name}
        rows={rows || 3}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        className={`border rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 ${className}`}
      />  
      {error && <span className="text-red-500 text-sm">{helperText}</span>}
    </div>
  );
};

export default CustomeTextArea;
